module.exports = __webpack_public_path__ + "img/comite01.ffe02d11.svg";